export const _state = {
    isGetRegulationResultsFetch: false,
    isCreateRegulationResultFetch: false,
    isUpdateRegulationResultFetch: false,
    errors: {},
    regulation_result: {},
    regulation_results: [],
};

export function regulationResultsReducer(state = _state, action) {

    switch (action.type) {

        case 'API_GET_REGULATION_RESULTS_CLOSE_FETCH':
            return {
                ...state,
                isGetRegulationResultsFetch: false,
            };

        case 'API_CREATE_REGULATION_RESULTS_CLOSE_FETCH':
            return {
                ...state,
                isCreateRegulationResultFetch: false,
            };

        case 'API_UPDATE_REGULATION_RESULTS_CLOSE_FETCH':
            return {
                ...state,
                isUpdateRegulationResultFetch: false,
            };

        case 'CLEAR_REGULATION_RESULT_ERRORS':
            return {
                ...state,
                errors: {},
            };

        case 'API_GET_REGULATION_RESULTS':
            return {
                ...state,
                isGetRegulationResultsFetch: true,
            };

        case 'API_GET_REGULATION_RESULTS_SUCCESS':
            return {
                ...state,
                regulation_results: action.payload.data,
                errors: {},
            };

        case 'API_GET_REGULATION_RESULTS_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_CREATE_REGULATION_RESULT':
            return {
                ...state,
                isCreateRegulationResultFetch: true,
            };

        case 'API_CREATE_REGULATION_RESULT_SUCCESS':
            return {
                ...state,
                errors: {},
                regulation_result: action.payload.data,
            };

        case 'API_CREATE_REGULATION_RESULT_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_UPDATE_REGULATION_RESULT':
            return {
                ...state,
                isUpdateRegulationResultFetch: true,
            };

        case 'API_UPDATE_REGULATION_RESULT_SUCCESS':
            return {
                ...state,
                errors: {},
                regulation_result: action.payload.data,
            };

        case 'API_UPDATE_REGULATION_RESULT_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'SET_EDIT_REGULATION_RESULT':
            return {
                ...state,
                regulation_result: action.payload.regulation_result,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/regulation_results.js